import { render, staticRenderFns } from "./RsCard.vue?vue&type=template&id=483a521b&scoped=true&"
import script from "./RsCard.vue?vue&type=script&lang=js&"
export * from "./RsCard.vue?vue&type=script&lang=js&"
import style0 from "./RsCard.vue?vue&type=style&index=0&id=483a521b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a521b",
  null
  
)

export default component.exports